import { FormattedMessage } from 'react-intl'

export default function BookNowPayLater() {
  return (
    <div className='fields'>
      <div className='payment-info-pan'>
        <div className='line'>
          <div className='pill green pan-lft'>
            <FormattedMessage
              id='book_now_pay_later'
              defaultMessage='Book now, pay later'
            />
          </div>
          <p className='text '>
            <FormattedMessage
              id='no_need_payments'
              defaultMessage='No need to enter any payment details now.'
            />
          </p>
        </div>
        <div className='line'>
          <h5 className='pan-lft'>
            <FormattedMessage
              id='payment_options'
              defaultMessage='Payment options'
            />
          </h5>
          <ul className='icons'>
            <li className='pm-icon-visa' />
            <li className='pm-icon-mc' />
            <li className='pm-icon-amex' />
          </ul>
        </div>
      </div>
    </div>
  )
}
